// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import { ensureGateCbOnAddressBar } from '@/utils/gate'
import { APP_NAME } from '@/utils/brand'
import { Toast } from 'vant'
import store from '@/store'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home/index.vue'),
        meta: {
            title: '首页',
            requiresAuth: true
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword/index.vue'),
        meta: {
            title: '忘记密码'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile/index.vue'),
        meta: {
            title: '个人中心',
            requiresAuth: true
        }
    },
    {
        path: '/app-download',
        name: 'AppDownload',
        component: () => import('@/views/AppDownloadPage/index.vue'),
        meta: {
            title: 'APP下载',
        }
    },
    {
        path: '/mall',
        name: 'Mall',
        component: () => import('@/views/Mall/index.vue'),
        meta: {
            title: '产品',
        }
    },
    {
        path: '/orders',
        name: 'OrderList',
        component: () => import('@/views/Mall/OrderList/index.vue'),
        meta: {
            requiresAuth: true,
            title: '购买记录'
        }
    },
    {
        path: '/address',
        name: 'Address',
        component: () => import('@/views/AddressManagement/index.vue'),
        meta: {
            requiresAuth: true,
            title: '地址管理'
        }
    },
    {
        path: '/address/add',
        name: 'AddressAdd',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/address/edit/:id',
        name: 'AddressEdit',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/bank-cards',
        redirect: '/',
    },
    {
        path: '/bank-cards/:pathMatch(.*)*',
        redirect: '/',
    },
    {
        path: '/verification',
        name: 'Verification',
        component: () => import('@/views/Verification/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/security',
        name: 'Security',
        component: () => import('@/views/Security/index.vue'),
        meta: {
            title: '提款密码设置',
            requiresAuth: true
        }
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('@/views/Help/index.vue'),
        meta: {
            title: '帮助中心',
            requiresAuth: true
        }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
        meta: {
            title: '关于我们',
            requiresAuth: true
        }
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('@/views/Legal/index.vue'),
        meta: {
            title: '用户服务协议',
            legalType: 'terms'
        }
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('@/views/Legal/index.vue'),
        meta: {
            title: '隐私政策',
            legalType: 'privacy'
        }
    },
    {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/Withdraw/index.vue'),
        meta: {
            title: '提现',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-bind',
        name: 'WithdrawBind',
        component: () => import('@/views/WithdrawBind/index.vue'),
        meta: {
            title: '提现信息绑定',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-asset',
        name: 'WithdrawAsset',
        component: () => import('@/views/WithdrawAsset/index.vue'),
        meta: {
            title: '提现到资产余额',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-history',
        name: 'WithdrawHistory',
        component: () => import('@/views/WithdrawHistory/index.vue'),
        meta: {
            title: '提现明细',
            requiresAuth: true
        }
    },
    {
        path: '/asset-history',
        name: 'AssetHistory',
        component: () => import('@/views/AssetHistory/index.vue'),
        meta: {
            title: '资金明细',
            requiresAuth: true
        }
    },
    {
        path: '/bind-bank-card',
        name: 'BindBankCard',
        component: () => import('@/views/BindBankCard/index.vue'),
        meta: {
            title: '绑定银行卡',
            requiresAuth: true
        }
    },
    {
        path: '/real-name',
        name: 'RealName',
        component: () => import('@/views/RealName/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/team',
        name: 'Team',
        component: () => import('@/views/Team/index.vue'),
        meta: {
            title: '我的团队',
            requiresAuth: true
        }
    },
    {
        path: '/invite',
        name: 'Invite',
        component: () => import('@/views/Invite/index.vue'),
        meta: {
            title: '分享奖励',
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/index.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/Register/index.vue'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/download/guide',
        name: 'downloadGuide',
        component: () => import('@/views/DownloadGuidePage/index.vue'),
        meta: {
            title: '下载指引'
        }
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/error/403.vue'),
        meta: {
            title: '无权访问'
        }
    },
    {
        path: '/monthly-sign-in',
        name: 'MonthlySignIn',
        component: () => import('@/views/MonthlySignIn/index.vue'),
        meta: {
            title: '每日签到',
            requiresAuth: true
        }
    },
    {
        path: '/earnings',
        name: 'Earnings',
        component: () => import('@/views/Earnings/index.vue'),
        meta: {
            title: '我的收益',
            requiresAuth: true
        }
    },
    {
        path: '/gift',
        name: 'Gift',
        component: () => import('@/views/Gift/index.vue'),
        meta: {
            title: '抽奖',
        }
    },
    {
        path: '/gift-history',
        name: 'GiftHistory',
        component: () => import('@/views/GiftHistory/index.vue'),
        meta: {
            title: '中奖记录',
        }
    },
    {
        path: '/stock',
        name: 'Stock',
        component: () => import('@/views/Stock/index.vue'),
        meta: {
            title: 'AI算力',
            requiresAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/error/404.vue'),
        meta: {
            title: '页面未找到'
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // 始终滚动到顶部
        return { top: 0 }
    }
})

// 白名单：不需要登录就可以访问的路由
const whiteList = ['/login', '/register', '/forgot-password', '/403', '/404', '/app-download', '/download/guide', '/terms', '/privacy']

router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title ? `${to.meta.title} - ${APP_NAME}` : APP_NAME

    const token = getToken()

    // 判断是否有token
    if (token) {
        if (to.path === '/login' || to.path === '/register') {
            // 已登录状态下访问登录页，重定向到首页
            next('/')
        } else {
            // 判断是否已经获取了用户信息
            if (store.state.user.name) {
                next()
            } else {
                try {
                    // 获取用户信息
                    await store.dispatch('user/getUserInfo')
                    next()
                } catch (error) {
                    // 获取用户信息失败，可能是token失效
                    await store.dispatch('user/logout')
                    Toast.fail('登录状态已过期，请重新登录')
                    next(`/login?redirect=${to.path}`)
                }
            }
        }
    } else {
        // 没有token
        if (whiteList.includes(to.path) || to.path.startsWith('/download/') || !to.meta.requiresAuth) {
            // 白名单中的页面或不需要认证的页面，直接访问
            next()
        } else {
            // 其他需要登录的页面，重定向到登录页
            next(`/login?redirect=${to.path}`)
        }
    }
})

router.afterEach((to) => {
    ensureGateCbOnAddressBar(to.path)
})

export default router